<template>
  <div v-if="link && link.length > 0">

    <div class="embed-responsive embed-responsive-16by9">
      <div id="player" data-plyr-provider="youtube" :data-plyr-embed-id="link"></div>
    </div>
    <PartsTempPreloader v-if="loading"/>

  </div>
  <template v-else>
    <div class="alert alert-info">
      {{ $t('accommodation-has-no-video-link') }}
    </div>
  </template>
</template>

<script setup lang="ts">
import {onMounted, ref} from "vue";
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';


const props = defineProps({
  link: String
});

const loading = ref(true);


onMounted(() => {
  const player = new Plyr('#player');
  setTimeout(() => {
    loading.value = false;
  }, 200)
})


</script>
